/* eslint-ignore */
// @ts-nocheck
import React from 'react';
import {
  ContainedButtonStyle as Button,
  TrailingIconContainer,
  LeadingIconContainer,
} from './styles';

const ContainedButton = (props) => {
  const {
    type,
    loading = false,
    LeadingIcon,
    TrailingIcon,
    children,
    ...rest
  } = props;
  return (
    <Button {...rest} type={type || 'button'}>
      {loading ? (
        <>
          <span>
            <i
              style={{ fontSize: 20, marginTop: 5 }}
              className="fa fa-spinner fa-pulse fa-3x fa-fw"
            />
          </span>
        </>
      ) : (
        <>
          {LeadingIcon && (
            <LeadingIconContainer>
              <LeadingIcon />
            </LeadingIconContainer>
          )}
          <span> {children} </span>
          {TrailingIcon && (
            <TrailingIconContainer>
              <TrailingIcon />
            </TrailingIconContainer>
          )}
        </>
      )}
    </Button>
  );
};

export default ContainedButton;
